import { Product } from 'constants/interface';
import { ProductTypeEnum } from 'constants/product';
import { useSelector } from 'hooks/store';
import {
  productsEntitiesSelector,
  productsIdsSelector,
} from 'state/slices/products';

interface ProductFilter {
  types?: ProductTypeEnum[]
  cultureId?: string
  varietyId?: string
}

export const useProducts = (filter?: ProductFilter): Product[] => {
  const productsEntities = useSelector(productsEntitiesSelector);
  const productsIds = useSelector(productsIdsSelector);
  const products = productsIds
    .map((productId) => productsEntities[productId])
    .filter((product) => !!product) as Product[];

  // Filters
  const filteredProducts = filter
    ? (
      products
        .filter((product) => {
          let verdict = true;

          if (filter.types && !filter.types.includes(product.type)) {
            verdict = verdict && false;
          }

          if (filter.cultureId && filter.cultureId !== product.variety.culture.id) {
            verdict = verdict && false;
          }

          if (filter.varietyId && filter.varietyId !== product.variety.id) {
            verdict = verdict && false;
          }

          return verdict;
        })
    ) : (
      products
    );

  return filteredProducts;
};
